import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MEMBERSHIP_BOTTOM_BANNER_ENABLED_FOR = createFcmDetails(
	'membership_bottom_banner_enabled_for',
	{
		owner: 'Membership Squad',
		context: 'Petition Details page',
		description: 'This FC controls the visibility of membership bottom banner on petition details page',
		import: false,
	},
);
